import styled from 'styled-components';
import { skeletonAnimation } from 'src/styles';

export const Avatar = styled.div`
  width: 2.25rem;
  height: 2.25rem;
  flex-shrink: 0;
  ${skeletonAnimation}
`;

Avatar.displayName = 'Avatar';

export const Author = styled.div`
  width: 7.875rem;
  height: 0.5rem;
  flex-shrink: 0;
  ${skeletonAnimation}
`;

Author.displayName = 'Author';

export const PostText = styled.div`
  width: 100%;
  height: 0.5rem;
  flex-shrink: 0;
  ${skeletonAnimation}
`;

PostText.displayName = 'PostText';

export const ReactionsWrapper = styled.div`
  max-width: 22.5rem;
  gap: var(--spacer-2);
  flex-wrap: wrap;
`;

ReactionsWrapper.displayName = 'ReactionsWrapper';

export const AllReactions = styled.div`
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
  ${skeletonAnimation}
`;

AllReactions.displayName = 'AllReactions';

export const Reaction = styled.div`
  width: 4.75rem;
  height: 2rem;
  flex-shrink: 0;
  ${skeletonAnimation}
`;

Reaction.displayName = 'Reaction';

export const PostInfoWrapper = styled.div`
  column-gap: var(--spacer-1);
`;

PostInfoWrapper.displayName = 'PostInfoWrapper';

export const PostInfo = styled.div`
  width: 3rem;
  height: 1.125rem;
  flex-shrink: 0;
  ${skeletonAnimation}
`;

PostInfo.displayName = 'PostInfo';
